<div
    cdkScrollable
    class="d-flex flex-column"
    [ngClass]="{
        'website-preview': websiteMode !== WebsiteMode.Live,
        'website-live': websiteMode === WebsiteMode.Live,
        'scroll-y': !isMobileOrTablet && websiteMode === WebsiteMode.Live
    }">
    <!--css classes for cursor pointer -->
    @if (!isMobileOrTablet) {
        <div
            #myheader
            [attr.data-sb-qa]="'website-page-header'"
            class="scss-website-page-header px-4 py-3 d-grid"
            [ngClass]="{
                'px-4': (websiteData.Template! | method: IsV1WebsiteTemplate),
                'scss-padding-x-100': !(websiteData.Template! | method: IsV1WebsiteTemplate)
            }">
            <!-- Desktop -->
            <ng-container>
                @if (websiteData.Template === WebsiteTemplate.Standard || websiteData.Template === WebsiteTemplate.Bold) {
                    <div class="d-flex align-items-center justify-content-between">
                        <ng-container *ngTemplateOutlet="websiteTitleLogo"></ng-container>
                        <div
                            class="d-flex"
                            [ngClass]="{ 'gap-5': socialLinksInHeader && (websiteData | method: HasSocialLinks) }">
                            <div
                                [attr.data-sb-qa]="'website-page-header-page-title-container'"
                                class="d-flex align-items-center flex-wrap scss-custom-header-gap justify-content-start ps-5">
                                <ng-container *ngTemplateOutlet="desktopMenu"></ng-container>
                            </div>
                            @if (socialLinksInHeader) {
                                <ng-container *ngTemplateOutlet="socialMediaIcons"></ng-container>
                            }
                        </div>
                    </div>
                } @else if (websiteData.Template === WebsiteTemplate.Minimalistic) {
                    <div class="scss-header-grid-tri-col-center-logo">
                        <div class="d-flex align-items-center flex-wrap scss-custom-header-gap"><ng-container *ngTemplateOutlet="desktopMenu"></ng-container></div>
                        <div class="scss-justify-self-center">
                            <ng-container *ngTemplateOutlet="websiteTitleLogo"></ng-container>
                        </div>
                        @if (socialLinksInHeader) {
                            <div class="scss-grid-item-justify-self-end"><ng-container *ngTemplateOutlet="socialMediaIcons"></ng-container></div>
                        }
                    </div>
                } @else if (websiteData.Template === WebsiteTemplate.Template1) {
                    <div class="d-flex flex-column justify-content-center align-items-center gap-space-20 padding-top-20 padding-bottom-8">
                        <ng-container *ngTemplateOutlet="websiteTitleLogo"></ng-container>
                        <div class="d-flex align-items-center flex-wrap scss-custom-header-gap"><ng-container *ngTemplateOutlet="desktopMenu"></ng-container></div>
                        @if (socialLinksInHeader) {
                            <div class="scss-grid-item-justify-self-end"><ng-container *ngTemplateOutlet="socialMediaIcons"></ng-container></div>
                        }
                    </div>
                } @else if (websiteData.Template === WebsiteTemplate.Template2 || websiteData.Template === WebsiteTemplate.Template4) {
                    <div
                        [ngClass]="{
                            'scss-header-grid-tri-col-center-menu': socialLinksInHeader,
                            'd-flex align-items-center justify-content-between': !socialLinksInHeader
                        }">
                        <ng-container *ngTemplateOutlet="websiteTitleLogo"></ng-container>
                        <div class="d-flex align-items-center flex-wrap scss-custom-header-gap scss-justify-self-center">
                            <ng-container *ngTemplateOutlet="desktopMenu"></ng-container>
                        </div>
                        @if (socialLinksInHeader) {
                            <div class="scss-grid-item-justify-self-end"><ng-container *ngTemplateOutlet="socialMediaIcons"></ng-container></div>
                        }
                    </div>
                } @else if (websiteData.Template === WebsiteTemplate.Template3) {
                    <div class="d-flex align-items-center justify-content-between">
                        <ng-container *ngTemplateOutlet="websiteTitleLogo"></ng-container>
                        <div class="d-flex align-items-center flex-wrap scss-custom-header-gap ps-5 scss-header-menu-last-child">
                            <ng-container *ngTemplateOutlet="desktopMenu"></ng-container>
                        </div>
                    </div>
                    @if (socialLinksInHeader) {
                        <div class="scss-grid-item-justify-self-end margin-y-16"><ng-container *ngTemplateOutlet="socialMediaIcons"></ng-container></div>
                    }
                } @else if (websiteData.Template === WebsiteTemplate.Template5) {
                    <div class="d-flex justify-content-between align-items-center margin-top-4">
                        <ng-container *ngTemplateOutlet="websiteTitleLogo"></ng-container>
                        <div class="d-flex align-items-center flex-wrap scss-custom-header-gap ps-5">
                            <ng-container *ngTemplateOutlet="desktopMenu"></ng-container>
                        </div>
                    </div>
                    @if (socialLinksInHeader) {
                        <div class="scss-grid-item-justify-self-end margin-y-16"><ng-container *ngTemplateOutlet="socialMediaIcons"></ng-container></div>
                    }
                }
            </ng-container>
        </div>
        <ng-container *ngTemplateOutlet="mainContent"></ng-container>
        <ng-container *ngTemplateOutlet="footerMenu"></ng-container>
    } @else {
        <lib-website-navigation-sidebar
            [websiteData]="websiteData"
            [ID]="currentPageID"
            [mode]="websiteMode"
            (navigationPageClicked)="NavigationPageClicked($event)">
            <ng-container
                *ngTemplateOutlet="websiteTitleLogo"
                websiteTitleLogoSelect></ng-container>
            <ng-container
                *ngTemplateOutlet="mainContent"
                mainContentSelect></ng-container>
            <ng-container
                *ngTemplateOutlet="socialMediaIcons"
                socialMediaSelect></ng-container>
            <ng-container
                *ngTemplateOutlet="footerMenu"
                footerMenuSelect></ng-container>
        </lib-website-navigation-sidebar>
    }

    <ng-template #socialMediaIcons>
        <div
            class="d-flex align-items-center"
            [ngClass]="{
                'justify-content-center': isMobile,
                'justify-content-end': !isMobile,
                'gap-space-35': !((websiteData.Template! | method: IsV1WebsiteTemplate) || isMobileOrTablet),
                'gap-2': (websiteData.Template! | method: IsV1WebsiteTemplate) || isMobileOrTablet
            }">
            @for (socialLink of websiteData.SocialMediaLinks | orderByKey: 'SocialMediaType'; track socialLink.ID) {
                <lib-icon
                    class="cursor-pointer"
                    [icon]="socialLink | socialMediaLinkIcon"
                    [size]="IconSize.Medium"
                    (click)="GoToSocialMediaSite(socialLink.Url!)"></lib-icon>
            }
        </div>
    </ng-template>

    <ng-template #desktopMenu>
        <ng-container
            *ngFor="let page of websiteData.WebsitePages"
            class="pe-5">
            @if (page.InMenu) {
                <div class="subNav">
                    <h6
                        (click)="NavigationPageClicked(page.ID)"
                        class="cursor-pointer scss-nav-text-truncate scss-website-block-customized-body-font"
                        [ngClass]="{ 'text-decoration-underline': page.ID === currentPageID || (currentPageID | method: IsPageParentOfViewableID : page) }">
                        <a
                            class="scss-custom-no-link-styling"
                            [href]="page.Slug"
                            onclick="return false;">
                            {{ page.Title }}
                        </a>
                    </h6>

                    @if (page.ChildPages.length > 0) {
                        <div class="subNavContent rounded-bottom scss-sub-nav-shadow">
                            <ng-container *ngFor="let childPage of page.ChildPages">
                                <p
                                    (click)="NavigationPageClicked(childPage.ID)"
                                    class="cursor-pointer scss-sub-nav-text-wrap"
                                    [ngClass]="{ 'text-decoration-underline': childPage.ID === currentPageID }">
                                    <a
                                        class="scss-custom-no-link-styling"
                                        [href]="childPage.Slug"
                                        onclick="return false;">
                                        {{ childPage.Title }}
                                    </a>
                                </p>
                            </ng-container>
                        </div>
                    }
                </div>
            }
        </ng-container>
    </ng-template>

    <ng-template #websiteTitleLogo>
        <ng-container *ngTemplateOutlet="websiteTitleLogoTemplate; context: { $implicit: true }"></ng-container>
    </ng-template>

    <ng-template #mainContent>
        <div
            class="flex-grow-1"
            cdkScrollable
            [@listAnimation]="animate"
            (@listAnimation.done)="AnimationEnd()">
            <div
                class="example-list h-100"
                cdkDropList
                id="pages"
                #boundary
                #pages="cdkDropList"
                [cdkDropListAutoScrollDisabled]="false"
                [cdkDropListAutoScrollStep]="15"
                (cdkDropListDropped)="Dropped($event)">
                @if (draw) {
                    <div
                        class="example-box"
                        *ngFor="let block of blocks; trackBy: TrackByID"
                        cdkDrag
                        [cdkDragDisabled]="true">
                        <div
                            class="example-custom-placeholder"
                            *cdkDragPlaceholder></div>
                        <ng-container>
                            @switch (block.WebsiteBlockType) {
                                @case (WebsiteBlockType.SignupForm) {
                                    <lib-signup-form-design-block
                                        *ngLet="block | method: WebsiteBlockDisplayItem.AsSignupForm as signupWidgetBlock"
                                        [websiteBlockData]="signupWidgetBlock">
                                        <ng-container header>
                                            <ng-container *ngTemplateOutlet="textMediaBlockHeader; context: { $implicit: signupWidgetBlock }"></ng-container>
                                        </ng-container>
                                    </lib-signup-form-design-block>
                                }
                                @case (WebsiteBlockType.ContactForm) {
                                    <lib-contact-form-design-block
                                        *ngLet="block | method: WebsiteBlockDisplayItem.AsContactForm as contactWidgetBlock"
                                        [websiteBlockData]="contactWidgetBlock">
                                        <ng-container header>
                                            <ng-container *ngTemplateOutlet="textMediaBlockHeader; context: { $implicit: contactWidgetBlock }"></ng-container>
                                        </ng-container>
                                        <ng-container body>
                                            <ng-container *ngTemplateOutlet="textMediaBlockBody; context: { $implicit: contactWidgetBlock }"></ng-container>
                                        </ng-container>
                                        <ng-container image>
                                            <ng-container *ngFor="let imageData of contactWidgetBlock.Images; trackBy: TrackByImage">
                                                <ng-container
                                                    *ngTemplateOutlet="
                                                        textMediaBlockImage;
                                                        context: { $implicit: imageData, blockType: contactWidgetBlock | method: PrepareScalingTypeData }
                                                    "></ng-container>
                                            </ng-container>
                                        </ng-container>
                                    </lib-contact-form-design-block>
                                }
                                @case (WebsiteBlockType.LoginForm) {
                                    <lib-login-form-design-block
                                        *ngLet="block | method: WebsiteBlockDisplayItem.AsLoginForm as loginWidgetBlock"
                                        [websiteBlockData]="loginWidgetBlock">
                                        <ng-container header>
                                            <ng-container *ngTemplateOutlet="textMediaBlockHeader; context: { $implicit: loginWidgetBlock }"></ng-container>
                                        </ng-container>
                                        <ng-container body>
                                            <ng-container *ngTemplateOutlet="textMediaBlockBody; context: { $implicit: loginWidgetBlock }"></ng-container>
                                        </ng-container>
                                        <ng-container image>
                                            <ng-container *ngFor="let imageData of loginWidgetBlock.Images; trackBy: TrackByImage">
                                                <ng-container
                                                    *ngTemplateOutlet="
                                                        textMediaBlockImage;
                                                        context: { $implicit: imageData, blockType: loginWidgetBlock | method: PrepareScalingTypeData }
                                                    "></ng-container>
                                            </ng-container>
                                        </ng-container>
                                    </lib-login-form-design-block>
                                }
                                @case (WebsiteBlockType.Blog) {
                                    <lib-blog-posts-design-block [websiteBlockData]="block | method: WebsiteBlockDisplayItem.AsBlog"></lib-blog-posts-design-block>
                                }
                                @case (WebsiteBlockType.Reviews) {
                                    <lib-reviews-design-block [websiteBlockData]="block | method: WebsiteBlockDisplayItem.AsReviews"></lib-reviews-design-block>
                                }
                                @case (WebsiteBlockType.Embed) {
                                    <ng-container *ngLet="block | method: WebsiteBlockDisplayItem.AsEmbed as embedBlock">
                                        @if (embedBlock.ContentType == WebsiteBlockEmbedContentType.Map) {
                                            <lib-map-design-block [websiteBlockData]="embedBlock"></lib-map-design-block>
                                        }

                                        @if (embedBlock.ContentType == WebsiteBlockEmbedContentType.Video) {
                                            <lib-video-design-block [websiteBlockData]="embedBlock"></lib-video-design-block>
                                        }
                                    </ng-container>
                                }
                                @case (WebsiteBlockType.TextAndMedia) {
                                    <ng-container *ngLet="block | method: WebsiteBlockDisplayItem.AsTextAndMedia as textMediaBlock">
                                        @if (
                                            (textMediaBlock | method: WebsiteBlockTextAndMediaDisplayItem.IsTextBlock) ||
                                            (textMediaBlock | method: WebsiteBlockTextAndMediaDisplayItem.IsTestimonialBlock)
                                        ) {
                                            <lib-text-design-block
                                                class="scss-display-block-text-and-media"
                                                [websiteBlockData]="textMediaBlock">
                                                <ng-container header>
                                                    <ng-container *ngTemplateOutlet="textMediaBlockHeader; context: { $implicit: textMediaBlock }"></ng-container>
                                                </ng-container>
                                                <ng-container body>
                                                    <ng-container *ngTemplateOutlet="textMediaBlockBody; context: { $implicit: textMediaBlock }"></ng-container>
                                                </ng-container>
                                                <ng-container image>
                                                    <ng-container *ngFor="let imageData of textMediaBlock.Images; trackBy: TrackByImage">
                                                        <ng-container
                                                            *ngTemplateOutlet="
                                                                textMediaBlockImage;
                                                                context: { $implicit: imageData, blockType: textMediaBlock | method: PrepareScalingTypeData }
                                                            "></ng-container>
                                                    </ng-container>
                                                </ng-container>
                                            </lib-text-design-block>
                                        }
                                        @if (textMediaBlock | method: WebsiteBlockTextAndMediaDisplayItem.IsHTMLBlock) {
                                            <lib-html-design-block [websiteBlockData]="textMediaBlock">
                                                <ng-container *ngTemplateOutlet="htmlBlock; context: { $implicit: block }"></ng-container>
                                            </lib-html-design-block>
                                        }
                                        @if (textMediaBlock | method: WebsiteBlockTextAndMediaDisplayItem.IsCallToActionBlock) {
                                            <lib-call-to-action-design-block [websiteBlockData]="textMediaBlock">
                                                <ng-container header>
                                                    <ng-container *ngTemplateOutlet="textMediaBlockHeader; context: { $implicit: textMediaBlock }"></ng-container>
                                                </ng-container>
                                                <ng-container body>
                                                    <ng-container *ngTemplateOutlet="textMediaBlockBody; context: { $implicit: textMediaBlock }"></ng-container>
                                                </ng-container>
                                            </lib-call-to-action-design-block>
                                        }
                                        @if (textMediaBlock | method: WebsiteBlockTextAndMediaDisplayItem.IsHeroBlock) {
                                            <lib-hero-design-block [websiteBlockData]="textMediaBlock">
                                                <ng-container header>
                                                    <ng-container *ngTemplateOutlet="textMediaBlockHeader; context: { $implicit: textMediaBlock }"></ng-container>
                                                </ng-container>
                                                <ng-container body>
                                                    <ng-container *ngTemplateOutlet="textMediaBlockBody; context: { $implicit: textMediaBlock }"></ng-container>
                                                </ng-container>
                                                <ng-container image>
                                                    <ng-container *ngFor="let imageBlock of textMediaBlock.Images; trackBy: TrackByImage">
                                                        <ng-container
                                                            *ngTemplateOutlet="
                                                                textMediaBlockImage;
                                                                context: { $implicit: imageBlock, blockType: textMediaBlock | method: PrepareScalingTypeData }
                                                            "></ng-container>
                                                    </ng-container>
                                                </ng-container>
                                            </lib-hero-design-block>
                                        }
                                        @if (textMediaBlock | method: WebsiteBlockTextAndMediaDisplayItem.IsGalleryBlock) {
                                            <lib-gallery-column-design-block
                                                class="scss-display-block-gallery-column"
                                                [websiteBlockData]="textMediaBlock">
                                                <ng-container header>
                                                    <ng-container *ngTemplateOutlet="textMediaBlockHeader; context: { $implicit: textMediaBlock }"></ng-container>
                                                </ng-container>

                                                <lib-gallery-column-design-block-item
                                                    *ngFor="let imageData of textMediaBlock.Images; trackBy: TrackByImage"
                                                    [imageData]="imageData"
                                                    [ngClass]="{
                                                        'scss-gallery-column-card':
                                                            textMediaBlock.TextAndMediaType === WebsiteBlockTextAndMediaType.GalleryCircleCardColumn ||
                                                            textMediaBlock.TextAndMediaType === WebsiteBlockTextAndMediaType.GallerySquareCardColumn
                                                    }">
                                                    <ng-container image>
                                                        <ng-container
                                                            *ngTemplateOutlet="
                                                                textMediaBlockImage;
                                                                context: { $implicit: imageData, blockType: textMediaBlock | method: PrepareScalingTypeData }
                                                            "></ng-container>
                                                    </ng-container>
                                                    <ng-container header>
                                                        <ng-container
                                                            *ngTemplateOutlet="textMediaBlockImageHeader; context: { $implicit: imageData }"></ng-container>
                                                    </ng-container>
                                                    <ng-container body>
                                                        <ng-container *ngTemplateOutlet="textMediaBlockImageBody; context: { $implicit: imageData }"></ng-container>
                                                    </ng-container>
                                                </lib-gallery-column-design-block-item>
                                            </lib-gallery-column-design-block>
                                        }
                                        @if (textMediaBlock | method: WebsiteBlockTextAndMediaDisplayItem.IsPhotoGalleryBlock) {
                                            @if (textMediaBlock.TextAndMediaType === WebsiteBlockTextAndMediaType.PhotoGalleryGrid) {
                                                <lib-photo-gallery-design-block [websiteBlockData]="textMediaBlock">
                                                    <lib-photo-gallery-design-block-item
                                                        *ngFor="let imageData of textMediaBlock.Images; let i = index; trackBy: TrackByImage"
                                                        [imageData]="imageData">
                                                        <div
                                                            image
                                                            class="h-100">
                                                            <ng-container
                                                                *ngTemplateOutlet="
                                                                    textMediaBlockImage;
                                                                    context: { $implicit: imageData, blockType: textMediaBlock | method: PrepareScalingTypeData }
                                                                "></ng-container>
                                                        </div>
                                                    </lib-photo-gallery-design-block-item>
                                                </lib-photo-gallery-design-block>
                                            } @else {
                                                <lib-photo-gallery-design-block
                                                    #galleryBlock
                                                    [websiteBlockData]="textMediaBlock">
                                                    <ng-container *ngFor="let imageData of textMediaBlock.Images; let index = index; trackBy: TrackByImage">
                                                        <lib-photo-gallery-design-block-item
                                                            [imageData]="imageData"
                                                            [ngClass]="{
                                                                'carousel-item-left':
                                                                    index ===
                                                                    (galleryBlock.middleImageIndex | method: GetCarouselPrevIndex : textMediaBlock.Images.length),
                                                                'carousel-item-center': index === galleryBlock.middleImageIndex,
                                                                'carousel-item-right':
                                                                    index ===
                                                                    (galleryBlock.middleImageIndex | method: GetCarouselNextIndex : textMediaBlock.Images.length),
                                                                'carousel-item-hidden':
                                                                    index !==
                                                                        (galleryBlock.middleImageIndex
                                                                            | method: GetCarouselPrevIndex : textMediaBlock.Images.length) &&
                                                                    index !==
                                                                        (galleryBlock.middleImageIndex
                                                                            | method: GetCarouselNextIndex : textMediaBlock.Images.length) &&
                                                                    index !== galleryBlock.middleImageIndex
                                                            }">
                                                            <div
                                                                image
                                                                class="h-100 w-100"
                                                                [ngClass]="{
                                                                    'opacity-50':
                                                                        textMediaBlock.TextAndMediaType ===
                                                                            WebsiteBlockTextAndMediaType.PhotoGalleryCarouselOverlay &&
                                                                        (index ===
                                                                            (galleryBlock.middleImageIndex
                                                                                | method: GetCarouselPrevIndex : textMediaBlock.Images.length) ||
                                                                            index ===
                                                                                (galleryBlock.middleImageIndex
                                                                                    | method: GetCarouselNextIndex : textMediaBlock.Images.length))
                                                                }">
                                                                <ng-container
                                                                    *ngTemplateOutlet="
                                                                        textMediaBlockImage;
                                                                        context: { $implicit: imageData, blockType: textMediaBlock | method: PrepareScalingTypeData }
                                                                    "></ng-container>
                                                            </div>
                                                        </lib-photo-gallery-design-block-item>
                                                    </ng-container>
                                                </lib-photo-gallery-design-block>
                                            }
                                        }
                                    </ng-container>
                                }
                            }
                        </ng-container>
                    </div>
                }
            </div>
        </div>
    </ng-template>

    <ng-template #footerMenu>
        @if (showFooter) {
            <div class="scss-website-page-footer d-flex align-items-center justify-content-center flex-column flex-sm-row px-sm-5 py-sm-0">
                <div class="col d-flex"><ng-container *ngTemplateOutlet="websiteTitleLogoTemplate; context: { $implicit: false }"></ng-container></div>
                <div class="order-sm-2 order-3 col-auto text-center"><ng-content select="[copyright]"></ng-content></div>
                @if (socialLinksInFooter) {
                    <div class="order-sm-3 order-2 pt-sm-0 pt-2 col"><ng-container *ngTemplateOutlet="socialMediaIcons"></ng-container></div>
                }
            </div>
        }
    </ng-template>

    <ng-template
        #websiteTitleLogoTemplate
        let-isHeader>
        <div
            class="cursor-pointer"
            (click)="GoToHomePage()">
            @if (!websiteData.HeaderLogoMediaLibraryItemID) {
                <h4
                    [attr.data-sb-qa]="isHeader ? 'website-page-header-title' : 'website-footer-title'"
                    class="scss-website-block-customized-body-font">
                    {{ websiteData.Title }}
                </h4>
            }
            @if (websiteData.HeaderLogoMediaLibraryItemID && headerLogoSource) {
                <img
                    [attr.data-sb-qa]="isHeader ? 'website-page-header-logo' : 'website-footer-logo'"
                    class="cursor-pointer"
                    data-clarity-mask="true"
                    [src]="headerLogoSource | trustUrl"
                    i18n-alt="@@CommonLogoLabel"
                    alt="Logo"
                    i18n-title="@@CommonLogoLabel"
                    title="Logo"
                    [ngClass]="{
                        'scss-logo-size-desktop': websiteData.HeaderLogoMediaLibraryItemID && headerLogoSource && !isMobileOrTablet,
                        'scss-logo-size-mobile': websiteData.HeaderLogoMediaLibraryItemID && headerLogoSource && isMobileOrTablet
                    }" />
            }
        </div>
    </ng-template>
</div>

<lib-website-svgs></lib-website-svgs>
